module.exports = __webpack_public_path__ + "media/images/pattern-0322e52ee5e437901cd76cea4eafb719.png";